import { Group } from "@mantine/core"
import { OperationsAdminVenueTalentTabs } from "src/components/operations/administrator/talent/OperationsAdminVenueTalentTabs"
import { EditOperationsAdminVenueTalentAction } from "src/components/operations/administrator/talent/OperationsAdminVenueTalentActions"
import { useAppState } from "src/state"
import { DrawerPageLayout } from "src/components/ui/DrawerPageLayout"
import { DrawerPageHeader } from "src/components/ui/DrawerPageHeader"
import { OperationsAdminVenueTalentView } from "src/components/operations/administrator/talent/OperationsAdminVenueTalentView"

export function OperationsAdminVenueTalentOverlay() {

    const { currentItem } = useAppState(state=>state.users)

    return (
        <DrawerPageLayout
            header={
                <DrawerPageHeader
                    title={`${currentItem?.dj_display}`} 
                    renderAction={ 
                        <Group gap="sm"> 
                            <EditOperationsAdminVenueTalentAction />
                        </Group>
                    }
                />
            }
        >
            <OperationsAdminVenueTalentTabs overlay={true}/>
            <OperationsAdminVenueTalentView/>
        </DrawerPageLayout>
    )

}